import React, { useEffect } from "react";
import { Footer } from "../components/Footer";
import { MobileAssessmentBar } from "../components/MobileAssessmentBar";
import { Navigation } from "../components/Navigation";
import { AssessmentSection } from "../components/home/AssessmentSection";
import { CoachingSection } from "../components/home/CoachingSection";
import { FaqSection } from "../components/home/FaqSection";
import { FinalCtaSection } from "../components/home/FinalCtaSection";
import { HelpSection } from "../components/home/HelpSection";
import { HeroSection } from "../components/home/HeroSection";
import { MethodSection } from "../components/home/MethodSection";
import { PhilosophySection } from "../components/home/PhilosophySection";
import { StorySection } from "../components/home/StorySection";
import { siteLinks } from "../data/site";
export function HomePage() {
  useEffect(() => {
    document.title = "Leo Tovar Method | Movement Assessment & Performance Coaching";
    const description = "Understand how you move with a professional movement assessment from Leo Tovar. Online worldwide and 1:1 coaching in Denver.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  return <div className="min-h-screen w-full bg-cream text-ink" data-id="element-245" data-mp="1rqagpfouumnd">
      <Navigation assessmentUrl={siteLinks.assessment} data-id="element-246" data-mp="1rrtyjaq5t5r9" />
      <main data-id="element-247" data-mp="1vqud2h1ltm8g">
        <HeroSection assessmentUrl={siteLinks.assessment} data-id="element-248" data-mp="1vsnjpwc7w6gg" />
        <PhilosophySection data-id="element-249" data-mp="20qp4qmt7efuk" />
        <MethodSection data-id="element-250" data-mp="20qfmjleehczf" />
        <HelpSection data-id="element-251" data-mp="20p49sw2z8uw6" />
        <AssessmentSection assessmentUrl={siteLinks.assessment} data-id="element-252" data-mp="20ss4vzo2lpd0" />
        <CoachingSection data-id="element-253" data-mp="25ql9wpdn0dbp" />
        <StorySection data-id="element-254" data-mp="25npa0vi8bekm" />
        <FaqSection data-id="element-255" data-mp="3c5ujwqaiu6v2" />
        <FinalCtaSection assessmentUrl={siteLinks.assessment} data-id="element-256" data-mp="3c6dutn1r7uzl" />
      </main>
      <Footer data-id="element-257" data-mp="3h4yrxdlplyjt" />
      <MobileAssessmentBar href={siteLinks.assessment} data-id="element-258" data-mp="3h4fkwrxlkukk" />
    </div>;
}